import React, { useState } from "react";
import styles from "./SLA3DPrintingForm.module.css";
import { Field, Formik, Form } from "formik";
import {
  Button,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import { submitFormSLA3D } from "../../actions/Form.action";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const SLA3DPrintingForm = ({ submitFormSLA3D, data }) => {
  const [submitting, setSubmitting] = useState(false);
  const [file, setFile] = useState(false);
  const navigate = useNavigate();
  const onSubmitHandeler = async (values) => {
    setSubmitting(true);
    if (!file) {
      toast.error("Please upload file!");
      setSubmitting(false);
      return;
    }
    if (Object.keys(data).length === 0) {
      toast.error("Please fill these fields!");
      setSubmitting(false);
      navigate("/order");
      return;
    }
    let check = await submitFormSLA3D(values, data, file);
    if (check === true) {
      setSubmitting(false);
      navigate(`/`);
    } else {
      setSubmitting(false);
    }
  };
  let initVals = {
    designNeeded: "Yes",
    color: "",
    details: "",
    quantity: "",
  };

  const OrderSchema = Yup.object().shape({
    designNeeded: Yup.string().notRequired(),
    color: Yup.string().required("Color is required!"),
    details: Yup.string().required("Details is required!"),
    quantity: Yup.string().required("Quantity  is required!"),
  });

  return (
    <div className={styles.wrapper}>
      <h2 className="pt-4 px-5">SLA 3D Printing Order</h2>
      <Formik
        initialValues={initVals}
        validationSchema={OrderSchema}
        enableReinitialize
        onSubmit={(values) => onSubmitHandeler(values)}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            <Container className="p-md-5 p-3 pt-3 pt-md-3">
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="designNeeded" className="d-block">
                        Design needed by TechnoWren?
                      </label>
                      {errors.designNeeded && touched.designNeeded ? (
                        <small className="text-danger">
                          {errors.designNeeded}
                        </small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Select}
                      placeholder="Type your designNeeded..."
                      name="designNeeded"
                      isValid={!errors.designNeeded && touched.designNeeded}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.designNeeded && touched.designNeeded}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="color" className="d-block">
                        Color preference
                      </label>
                      {errors.color && touched.color ? (
                        <small className="text-danger">{errors.color}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your color preference..."
                      name="color"
                      isValid={!errors.color && touched.color}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.color && touched.color}
                    />
                  </InputGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="details" className="d-block">
                        Details
                      </label>
                      {errors.details && touched.details ? (
                        <small className="text-danger">{errors.details}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your details..."
                      name="details"
                      isValid={!errors.details && touched.details}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.details && touched.details}
                    ></Field>
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="quantity" className="d-block">
                        Quantity (According to the files)
                      </label>
                      {errors.quantity && touched.quantity ? (
                        <small className="text-danger">{errors.quantity}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type your quantity ..."
                      name="quantity"
                      isValid={!errors.quantity && touched.quantity}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.quantity && touched.quantity}
                    />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <BootstrapForm.Group controlId="formFile" className="mb-3">
                    <BootstrapForm.Label>
                      SLA Printing Files *
                    </BootstrapForm.Label>
                    <BootstrapForm.Control
                      onChange={(e) => setFile(e.target?.files)}
                      type="file"
                    />
                  </BootstrapForm.Group>
                </Col>
              </Row>
              <Row>
                <Col className="pt-3 d-flex justify-content-center align-items-center">
                  <Button
                    type="submit"
                    className={`.btn_primary ${styles.btn}`}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Order"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.form.form,
});
export default connect(mapStateToProps, { submitFormSLA3D })(SLA3DPrintingForm);
